import * as i0 from "@angular/core";
// TODO: Change this functions to be a service, so it can be properly injected, mocked and tested
/**
 * Update the state with a page entities that include item entities, e.g. fuel receipts, distances
 * The page entities use the pageNumber as id
 * @param state: the state to be updated
 * @param payload: the payload used to update the state
 */
export function updateStateWithPageEntities(state, payload) {
    // get the payload
    const { items, totalSize } = payload;
    // retrieve the pageEntity
    const pageEntity = state.entities[state.pageNumber];
    // retrieve itemEntities(with id as entity id)
    const stateItemEntities = pageEntity
        ? Object.assign({}, pageEntity.items) : {};
    // merge items
    const itemEntities = items.reduce((reducedEntities, item) => {
        return Object.assign({}, reducedEntities, { [item.id]: item });
    }, {} //stateItemEntities
    );
    const entities = Object.assign({}, state.entities, { [state.pageNumber]: Object.assign({}, pageEntity, { items: itemEntities }) });
    return Object.assign({}, state, { entities, totalSize: totalSize, isLoading: false, isLoaded: true });
}
/**
 * Convert array with id, e.g. [{id:"1"},{id:"2"}] to entities, e.g. {"1":{id:"1"},"2":{id:"2"}}
 * for more efficient query
 * @param itemArray the array to be converted
 * @param initialValue the initial entities for merging with new array items
 * @returns the entities
 */
export function arrayToEntities(itemArray, initialValue) {
    return itemArray.reduce((reducedEntities, item) => {
        return Object.assign({}, reducedEntities, { [item.id]: item });
    }, initialValue);
}
export class EntityMappingService {
    mapResponseToPagePayload(response, transformer) {
        return {
            items: response.body.map(transformer.fromAPI),
            totalSize: +response.headers.get('x-total-count')
        };
    }
}
EntityMappingService.ngInjectableDef = i0.defineInjectable({ factory: function EntityMappingService_Factory() { return new EntityMappingService(); }, token: EntityMappingService, providedIn: "root" });
